import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {IconAssetLinkItemSchema} from '../components/iconAssetLinkItem'
import {IconItemSchema} from '../components/iconItem'
import {IconLinkItemSchema} from '../components/iconLinkItem'
import {ImageLinkItemSchema} from '../components/imageLinkItem'
import {LinkSchema} from '../components/link'
import {MediaSchema} from '../components/media'
import {RiverBreakoutSchema} from '../components/riverBreakout'
import {SubnavSchema} from '../components/subnav'
import {TextItemSchema} from '../components/textItem'

export const CategoryHeroVariantEnum = z.enum(['Default', '50/50', 'Image Cards', 'Icon Cards'])

export type CategoryHeroVariant = z.infer<typeof CategoryHeroVariantEnum>

const CategoryIndexCardsVariantEnum = z.enum(['Icon Cards', 'Image Cards'])
const CategoryIndexSocialProofVariantEnum = z.enum(['Quote', 'Brand Banner'])
const CategoryIndexBreakoutVariantEnum = z.enum(['Breakout', 'Carousel'])

export const TemplateFlexSuiteCategorySchema = buildEntrySchemaFor('templateFlexSuiteCategory', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      subNav: safeOptional(SubnavSchema),
      introLogos: safeOptional(z.array(z.string())),
      introLogoLink: safeOptional(LinkSchema),
      introStats: safeOptional(z.array(TextItemSchema)),
      heroHeading: RichTextSchema,
      heroLabel: z.string().optional(),
      heroDescription: safeOptional(RichTextSchema),
      heroVariant: safeOptional(CategoryHeroVariantEnum),
      heroAsset: safeOptional(MediaSchema),
      heroCtaOne: LinkSchema,
      heroCtaTwo: safeOptional(LinkSchema),
      heroImageCards: safeOptional(z.array(ImageLinkItemSchema)),
      heroIconCards: safeOptional(z.array(IconItemSchema)),
      sectionIntroHeading: safeOptional(RichTextSchema),
      sectionIntroLabel: z.string().optional(),
      sectionIntroDescription: safeOptional(RichTextSchema),
      sectionIntroLink: safeOptional(LinkSchema),
      breakoutVariant: safeOptional(CategoryIndexBreakoutVariantEnum),
      featureRiverBreakout: safeOptional(RiverBreakoutSchema),
      featureBreakoutTabs: safeOptional(z.array(IconAssetLinkItemSchema)),
      cardsVariant: safeOptional(CategoryIndexCardsVariantEnum),
      cardsIconItems: safeOptional(z.array(IconLinkItemSchema)),
      cardsImageItems: safeOptional(z.array(ImageLinkItemSchema)),
      indexTestimonialVariant: safeOptional(CategoryIndexSocialProofVariantEnum),
      indexTestimonialLink: safeOptional(LinkSchema),
      indexTestimonialLogo: z.string().optional(),
      indexTestimonialQuote: safeOptional(RichTextSchema),
      indexTestimonialImage: safeOptional(AssetSchema),
      indexTestimonialLabel: z.string().optional(),
      indexTestimonialName: z.string().optional(),
      indexTestimonialTitle: z.string().optional(),
    }),
  ),
})

export type TemplateFlexSuiteCategory = z.infer<typeof TemplateFlexSuiteCategorySchema>
